import React, { useEffect } from 'react';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';

/**
 * Modal Popup Items Components
 * @param {*} props - Object
 */
const ToastModalCompItemsComponent = props => {
  const { classNames, show, autoFocus, modalTitleId, childrenTemplate } = props;
  const { AUTO, HIDDEN } = START_ORDER_CONSTANTS;
  useEffect(() => {
    document.querySelector('body').style.overflow = HIDDEN;
    return () => {
      document.querySelector('body').style.overflow = AUTO;
    };
  });

  return (
    <div show={show.toString()} className={classNames} autoFocus={autoFocus || false} data-testid={modalTitleId}>
      <div className='modal-content' tabIndex='-1' aria-labelledby={modalTitleId} role='dialog'>
        {childrenTemplate}
      </div>
    </div>
  );
};

/**
 * Modal Popup Item Component
 * @param {*} props - Object
 */
const ToastModalCompItems = props => <ToastModalCompItemsComponent {...props} />;

export default ToastModalCompItems;
